<template>
  <div v-if="!loading" class="full-height">
    <div v-if="routeMatchesComponent()" class="full-height relative p3">
      <Loader v-if="loadingContent" />
      <div v-else>
        <div v-for="billet in ebillets" :key="billet" class="flex flex-wrap border-bottom mb1 white-bg">
          <div
            class="flex-auto no-box flex flex-wrap pointer action p1"
            @click="store.commit('setTime', 0); selectBillet(billet.uuid);"
          >
            <div class="col-10 no-box pl2 flex items-center">
              <div class="col-12 pr2 no-box">
                <span class="block h5n"> {{ billet.product_name }} - <strong> {{ billet.customer.firstname }} {{ billet.customer.lastname }} </strong></span>
                <h3 v-if="!billet.unlimited_usage && billet.remainingQuantity" class="cond h5n my0">
                  {{ billet.remainingQuantity }}
                  <span v-if="billet.remainingQuantity == 1"> session restante</span>
                  <span v-else> sessions restantes</span>
                </h3>
                <span v-if="billet.contremarque" class="warning-message">Pense à échanger ta contremarque pour pouvoir réserver tes cours</span>
                <!-- <span> {{billet.uuid}}</span> -->
              </div>
            </div>

            <div class="col-2 no-box flex justify-end">
              <i class="breadcrumb-arrow red bold flex items-center p2 icon-angle-right-icon"></i>
            </div>
          </div>
        </div>

        <p v-if="ebillets.length === 0" class="h5n bold center warning m0">Vous n'avez pas d'e-billet en cours de validité.</p>
      </div>
    </div>

    <!-- TODO Improves -->
    <div v-else class="flex flex-column flex-auto full-height">
      <Transition>
        <Modal v-if="showModal">
          <template #body>
            <div class="flex items-center container-cart justify-center full-height">
              <div>
                <!-- SUCCESS -->
                <div v-if="successModal" class="mb5 col-12 success-checkmark">
                  <div class="check-icon">
                    <span class="icon-line greener-bg line-tip"></span>
                    <span class="icon-line greener-bg line-long"></span>
                    <div class="icon-circle"></div>
                    <div class="icon-fix"></div>
                  </div>
                </div>
                <div v-else class="mb5 center col-12">
                  <i style="font-size: 88px;" class="icon red line-height-2 icon-not-check-icon"></i>
                </div>
                <div class="h2 center" :class="successModal ? 'green': 'red'">
                  <h2 class="h2n">{{ modalMessage }}</h2>
                </div>
                <div class="mt1 center my2">
                  <Button text="Fermer" class="col-12" btn-color="red" :action="closeModal" />
                </div>
              </div>
            </div>
          </template>
        </Modal>
      </Transition>

      <DetailedBreadcrumb />

      <NotFound v-if="notFound && !loadingContent" />

      <div v-else-if="!loading" class="flex flex-column full-height relative p3">
        <BilletsCarousel v-if="ebillets && ebillets.length" :billets="ebillets" :change="billetChanged" />
        <Loader v-if="loadingContent" />

        <div v-else class="flex flex-column">
          <div v-if="billetType === 'single-session' && ['GroupSessionActivityList', 'SessionActivityList'].includes(route.name)" class="flex h5n pt2 px1"> Pour échanger votre séance, sélectionner le nouveau créneau souhaité.</div>
          <div v-if="session && ['GroupSessionActivityList', 'SessionActivityList'].includes(route.name)" class="col-12 p2 flex justify-between items-center white-bg my2 border-blue">
            <h5 class="h6n m0 capitalize">
              {{ session.dateLabel }}
            </h5>
            <h5 class="h6n m0">
              {{ `${session.startTime} - ${session.endTime}` }}
            </h5>
          </div>

          <ActivityCarousel v-else-if="selectedActivity.length && selectedActivity.length > 1 && route.name === 'SessionsPlanner'" :activities="selectedActivity" />
          <div v-show="!['GroupSessionActivityList'].includes($route.name)" class="flex col-12 items-center sticky top-0 col z4 grey-bg">
            <WeekNavbar :id="route.params.billet_uuid" :time="time" :label="timeLabel" :change="changeTime" :is-daily="selectedOption === 'Jour'" />
            <CustomSelect
              class="ml1 col-2"
              :options="Object.keys(dateOptions)"
              :default="timeFrame"
              @input="selectedOption = $event"
            />
          </div>
          <span v-if="['SessionsPlanner', 'GroupSessionsPlanner'].includes(route.name) && maxActivitiesLabel !== ''" class="h6n block col-12 red p1">
            <i class="icon h6n red icon-stop m1"></i> Le nombre maximal de réservation est {{ maxActivitiesLabel }}.
          </span>
          
          <p v-if="route.name === 'ActivitiesList' && activities.length === 0 && !blocked" class="h5n bold center warning m0 mt3">Vous n'avez pas d'activités.</p>

          <div v-else-if="blocked">
            <div class="lg-hide sm-hide md-hide">
              <p class="h5n bold center warning m0 mt3">Réservation impossibler pour cause d'impayé.</p>
              <p class="h5n bold center warning m0mt3">Modifiez vos coordonnées bancaires pour effectuer des réservations à nouveau.</p>
            </div>
            <div class="xs-hide">
              <p class="h5n bold center warning m0 mt3">Réservation impossibler pour cause d'impayé. Modifiez vos coordonnées bancaires pour effectuer des réservations à nouveau.</p>
            </div>
          </div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, inject, provide, ref, computed, watch, reactive } from 'vue';
import { useRouter, useRoute, onBeforeRouteUpdate } from 'vue-router';
import { useStore } from 'vuex';

import {
  differenceInWeeks,
  differenceInDays,
  format,
  parseISO,
  startOfDay,
  startOfWeek,
  add,
  endOfWeek
} from 'date-fns';
import { routeIsCurrentComponent, isInImpersonateModeNotification } from '@/mixins/utils';

import Loader from '@/components/common/Loader';
import { getActivities, reserveSession, cancelReservation, exchangeSession } from '@/mixins/requests';
import WeekNavbar from '@/components/reservations/WeekNavbar';
import BilletsCarousel from '@/components/reservations/BilletsCarousel';
import ActivityCarousel from '@/components/reservations/ActivityCarousel';
import DetailedBreadcrumb from '@/components/common/DetailedBreadcrumb';
import NotFound from '@/components/common/NotFound';
import Modal from '@/components/blocks/Modal';
import Button from '@/components/elements/Button';
import CustomSelect from '@/components/common/CustomSelect';

export default {
  components: { WeekNavbar, DetailedBreadcrumb, NotFound, Modal, Button, BilletsCarousel, ActivityCarousel, Loader, CustomSelect },
  setup () {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const ebillets = inject('ebillets');
    const ebillet = ref(null);
    const selectedBilletIndex = ref(null);
    const selectedOption = ref('Semaine');
    const calendarDay = computed(() => {
      const date = store.getters.calendarDay(route.params.billet_uuid);
      if (!date) {
        return parseISO(format(startOfDay(new Date()), 'yyyy-MM-dd'));
      }

      return parseISO(format(startOfDay(new Date(date)), 'yyyy-MM-dd'));
    });
    const weekOffset = computed(() => (differenceInWeeks(startOfWeek(calendarDay.value, { weekStartsOn: 1 }), startOfWeek(new Date(), { weekStartsOn: 1 }))));
    const dayOffset = computed(() => differenceInDays(calendarDay.value, startOfDay(new Date())));

    const dateOptions = reactive({ Jour: 1, Semaine: 7 });
    const notFound = ref(false);
    const showModal = ref(false);
    const successModal = ref(true);
    const modalMessage = ref('');

    const isInternalSession = computed(() => store.state.siteInfo.is_internal_session || null);
    const workspace = computed(() => store.state.siteInfo.workspace || []);
    const loading = computed(() => store.state.loading);
    const blocked = ref(false);
    const loadingContent = computed(() => store.state.loadingContent);
    const activities = computed(() => store.state.activities || []);
    const selectedActivity = computed(() => store.state.selectedActivity || []);
    const session = computed(() => store.state.session);
    const selected = computed(() => store.state.selected || 0);
    const time = computed(() => store.state.time || 0);
    const timeLabel = computed(() => store.state.timeLabel || {});
    const timeFrame = computed(() => store.state.timeFrame || {});

    const maxActivitiesLabel = computed(() => {
      let label = '';
      if (selectedActivity.value && selectedActivity.value.length) {
        const filteredActivities = selectedActivity.value.filter(a => a.max_amount && ((selected.value || []).includes(a.group) || (selected.value || []).includes(a.name)));
        filteredActivities.map((activity, index) => {
          label += ` de ${activity.max_amount} pour ${activity.name}${index < filteredActivities.length - 1 ? ',' : ''}`;
        });
      }
      return label;
    });
    const commonSessionData = computed(() => ({
      user_logged: store.state.user,
      workspace: workspace.value,
      passCode: ebillet.value.qrcode,
      participant: ebillet.value.customer,
      technologie: ebillet.value.codeTechnologie,
      horanetProductReference: ebillet.value.horanet_product_reference,
      product_uuid: ebillet.value.product_uuid,
      order_uuid: ebillet.value.order_uuid,
      contract_number: ebillet.value.numeroContrat
    }));

    const computeSessionData = s => ({
      ...commonSessionData.value,
      sessionCode: s.code,
      idActivity: s.code,
      sessionName: s.type,
      startTimestamp: s.startTimestamp,
      endTimestamp: s.endTimestamp,
      isInternalSession: isInternalSession.value
    });

    const closeModal = () => { showModal.value = false; };

    // REDIRECTS DEPENDING ON NUMBER OF GROUPS AND ROUTE PARAMS
    const whereNext = billet => {
      if (activities.value.length > 1) {
        if (session.value) {
          router.push({ name: 'SessionActivityList' });
        } else if (selectedActivity.value.length) {
          router.push({ name: 'SessionsPlanner' });
        } else {
          router.push({ name: 'ActivitiesList', params: { billet_uuid: billet.uuid } });
        }
      } else if (activities.value.length === 1) {
        if (session.value) {
          router.push({ name: 'GroupSessionActivityList' });
        } else {
          router.push({ name: 'GroupSessionsPlanner', params: { billet_uuid: billet.uuid } });
        }
      } else {
        router.push({ name: 'ActivitiesList', params: { billet_uuid: billet.uuid } });
        // notFound.value = false;
      }
      store.commit('setContremarque', billet.order_contremarque);
    };

    const getBilletActivities = async billet => {
      if (!billet.value) {
        store.commit('setActivities', null);
        store.commit('setActivitiesList', null);
        return [];
      }
      store.commit('setLoadingContent', true);

      const isDaily = timeFrame.value === 'Jour';
      const start = isDaily || !weekOffset.value ? format(add(isDaily ? calendarDay.value : new Date(), { hours: 1 }), 'yyyy-MM-dd') : format(startOfWeek(calendarDay.value, { weekStartsOn: 1 }), 'yyyy-MM-dd');
      // const startInDate = parseISO(start);
      const end = isDaily ? start : format(endOfWeek(calendarDay.value, { weekStartsOn: 1 }), 'yyyy-MM-dd');

      const data = {
        uuid: billet.value.customer.uuid,
        workspace: workspace.value,
        product_reference: billet.value.horanet_product_reference,
        start: start,
        end: end,
        qrcode: billet.value.qrcode,
        isDaily: timeFrame.value === 'Jour',
        product_uuid: billet.value.product_uuid
      };
      if (billet.value.blocked) {
        blocked.value = true;
        store.commit('setLoadingContent', false);
        whereNext(billet.value);
        return [];
      }

      return getActivities(data).then(async response => {
        if (response && response.activities) {
          store.commit('setBilletType', billet.value.type);
          store.commit('setActivities', response.activities);
          store.commit('setActivitiesList', response.activitiesList);
          store.commit('setTimeLabel', response.timeLabel);

          if (session.value) {
            const foundActivity = response.activities.find(activity => activity.group === session.value.type);
            foundActivity?.days?.find(day => {
              let sessionAux = null;
              sessionAux = day.items.find(item => Object.values(item.activities).some(act => act.code === session.value.code));

              if (sessionAux) {
                store.commit('setSession', sessionAux);
                return true;
              }
              return false;
            });
          }
          if (response.activities.length === 1) {
            store.commit('setSelectedActivity', response.activities);
            store.commit('setSelectedActivityKey', response.activities[0].name || response.activities[0].group);
          }

          whereNext(billet.value);
          store.commit('setLoadingContent', false);

          return response.activities;
        }
        return [];
      }).catch(() => {
        store.commit('setLoadingContent', false);
        return [];
      });
    };

    const reserve = async s => {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoadingContent', true);
      const data = computeSessionData(s);

      /*
        !contremarque qrcode -> 12 digits
        contremarque qrcode -> 13 digits
        contremarque bracelete qrcode -> 8 digits
      */
      modalMessage.value = ebillet.value.contremarque ? 'Pense à échanger ta contremarque pour réserver' : 'Une erreur s’est produite lors de votre réservation';

      successModal.value = false;

      await reserveSession(data).then(res => {
        if (res.success) {
          modalMessage.value = 'Réservation réussie';
          successModal.value = true;
        } else if (res.errorMessage) {
          modalMessage.value = res.errorMessage;
        }
      }).catch(() => []).finally(async () => {
        store.commit('setLoading', false);
        await getBilletActivities(ebillet);
        showModal.value = true;
      });
    };

    const exchange = async s => {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoadingContent', true);
      const data = computeSessionData(s);

      /*
        !contremarque qrcode -> 12 digits
        contremarque qrcode -> 13 digits
        contremarque bracelete qrcode -> 8 digits
      */
      modalMessage.value = ebillet.value.contremarque ? 'Pense à échanger ta contremarque pour réserver' : 'Une erreur s’est produite lors de votre réservation';

      successModal.value = false;

      await exchangeSession(data).then(res => {
        if (res.success) {
          modalMessage.value = 'Échange réussie';
          successModal.value = true;
        }
      }).catch(() => []).finally(async () => {
        store.commit('setLoading', false);
        await getBilletActivities(ebillet);
        showModal.value = true;
      });
    };

    const cancel = async s => {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoadingContent', true);

      const data = {
        workspace: workspace.value,
        sessionCode: s.code,
        numeroContrat: s.numeroContrat,
        user: ebillet.value.customer.uuid,
        sessionName: s.type,
        startTimestamp: s.startTimestamp,
        endTimestamp: s.endTimestamp
      };

      modalMessage.value = 'Une erreur s’est produite lors de l’annulation de votre réservation';
      successModal.value = false;

      await cancelReservation(data).then(res => {
        if (res.success) {
          modalMessage.value = 'Annulation réussie';
          successModal.value = true;
        }
      }).catch(() => []).finally(async () => {
        store.commit('setLoading', false);
        await getBilletActivities(ebillet);
        showModal.value = true;
      });
    };

    const changeTime = async val => {
      await getBilletActivities(ebillet);
    };

    const selectBillet = async (uuid, index = null, clear = true) => {
      if (clear) {
        store.commit('resetCalendarDays');
        store.commit('setSelected', []);
        store.commit('setSession', null);
        store.commit('setSelectedActivity', []);
        store.commit('setSelectedActivityKey', null);
        store.commit('setBilletType', null);
        blocked.value = false;
      }
      if (index === null) {
        ebillets.value?.map((billet, i) => {
          if (billet.uuid === uuid) {
            ebillet.value = billet;
            selectedBilletIndex.value = i;
          }
        });
      } else {
        ebillet.value = ebillets.value[index];
      }

      await getBilletActivities(ebillet);
    };

    const billetChanged = index => {
      const { uuid } = ebillets.value[index];
      router.push({ name: 'ActivitiesList', params: { billet_uuid: uuid } });
      selectBillet(uuid, index, true);
    };

    watch(selectedOption, async newValue => {
      store.commit('setTimeFrame', newValue);

      await selectBillet(route.params.billet_uuid, null, false);
    });

    watch(ebillets, async () => {
      // TODO - CLEAR SELECTED FROM STORE WHEN REFRESH ON ACTIVITIES LIST ROUTE
      if (route.params.billet_uuid) {
        await selectBillet(route.params.billet_uuid, null, false);
        // notFound.value = activities.value.length;

        if (['SessionActivityList', 'GroupSessionActivityList'].includes(route.name)) {
          notFound.value = !session.value || !ebillets.value.some(e => e.uuid === route.params.billet_uuid);
        }
      }
    });

    onBeforeRouteUpdate(to => {
      if (['SessionsPlanner', 'ActivitiesList'].includes(to.name)) {
        // notFound.value = !activities.value.length;
      }
    });

    provide('cancel', cancel);
    provide('exchange', exchange);
    provide('reserve', reserve);
    provide('selectedIndex', selectedBilletIndex);
    provide('showModal', showModal);
    provide('successModal', successModal);
    provide('modalMessage', modalMessage);
    const billetType = computed(() => store.state.billetType);

    return {
      weekOffset,
      dayOffset,
      ebillets,
      ebillet,
      time,
      timeFrame,
      store,
      route,
      selectBillet,
      timeLabel,
      session,
      changeTime,
      loading,
      loadingContent,
      billetChanged,
      activities,
      selectedActivity,
      notFound,
      showModal,
      modalMessage,
      closeModal,
      successModal,
      maxActivitiesLabel,
      selectedOption,
      dateOptions,
      routeMatchesComponent,
      billetType,
      blocked
    };
  }
};
</script>

<style lang="scss" scoped>
.action:hover .breadcrumb-arrow{
  color: white;
}

.border-blue{
  border: 1px solid #00a6c6;
  color: #00a6c6;
}

.no-border-top{
  border-top: 0;
}

</style>
